import { DashboardIntegration } from '../../../../domain';

export function isFullfilledOrIgnored(integration: DashboardIntegration) {
    return integration.isFulfilled || (integration.allowIgnore && integration.isIgnored);
}

export function canIgnore(integration: DashboardIntegration) {
    return !integration.isFulfilled && !!integration.allowIgnore;
}
